import React from 'react'

import Cards from '../components/Cards/Cards'

import patchnote from '../data/Patchnotes/patchnote.json'

import './PatchNote.scss'

function PatchNote(props) {
	return (
		<div className='Patches'>
			{patchnote.map((currentNote, index) => (
				<Cards Name={currentNote.date} key={currentNote.date + index}>
					<div className='News1'>
						{currentNote.added ? (
							<div className='Added'>
								<p>Added</p>
								<ul>
									{currentNote.added.map((newAdd, index) => (
										<li key={'added' + index}> {newAdd}</li>
									))}
								</ul>
							</div>
						) : null}
						{currentNote.fixed ? (
							<div className='Fixed'>
								<p>Fixed</p>
								<ul>
									{currentNote.fixed.map((newFix, index) => (
										<li key={'fixed' + index}> {newFix}</li>
									))}
								</ul>
							</div>
						) : null}
						{currentNote.notes ? (
							<div className='Notes'>
								<p>Notes</p>
								<ul>
									{currentNote.notes.map((newNote, index) => (
										<li key={'note' + index}> {newNote}</li>
									))}
								</ul>
							</div>
						) : null}
					</div>
				</Cards>
			))}
		</div>
	)
}

export default PatchNote
